module.exports = __webpack_public_path__ + "img/815.95f396f6.png";